import React, { Fragment, useEffect, useState, useContext } from "react";

import {useJobEditMutation} from "../services/jobsApi";
import {useResolveEscalationApiMutation, useGetEscalationMainReasonSubReasonQuery} from "../services/jobsApi";
import { Mask } from "../utils/mask";

import BasicModalConfirmation from "./basicModalConfirmation";
import RadioButton from "./RadioButton";

import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import { parseToEasternTime } from './../utils/dates';
import BasicModalInformation from "./basicModalInformation";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../features/auth/authSlice";
import { Delete } from "@material-ui/icons";
import DeleteJobActionButton from "../screens/jobDetailsTabs/components/DeleteJobActionButton";

function getReturnToBeeLabel(currentOwner) {
  let { firstName, lastName, id } = (currentOwner || {});
  if (!firstName || !lastName) return "return to  previous bee owner (ID: " + id + ")";
  return `Return to ${firstName} ${lastName} (ID: ${id})`;
}

function ResolveEscalationModal({ activeEscalation, userCanEditJob, jobInfo, escalation, setEscalation }) {
  const user = useSelector(selectCurrentUser);
  

  const [initJobEdit, {isLoading: jobEditIsLoading}] = useJobEditMutation();
  const [initResolveEscalationApi, {isLoading: resolveEscalationApiIsLoading}] = useResolveEscalationApiMutation();


  const history = useHistory();

  const escalationReasons = useGetEscalationMainReasonSubReasonQuery();
  const [issueResolvedNote, setissueResolvedNote] = useState("");
  const [confirmEdit, setConfirmEdit] = useState(false);
  const [error, setError] = useState([]);


  const [resolveOptions, setResolveOptions] = useState(null); //A: can be "cancelJob" or "returnToOwner";
  const [returnJobToBee, setReturnJobToBee] = useState(false);
  const [resolveEscalationError, setResolveEscalationError] = useState(null);

  function handleCancelJob() {
    if (resolveOptions == "cancelJob") return setResolveOptions(null);
    setResolveOptions("cancelJob");
  }

  function handleReturnToOwner() {
    if (resolveOptions == "returnToOwner") return setResolveOptions(null);
    setResolveOptions("returnToOwner");
  }

  async function onLocalSubmit() {
    setError([]);
    if (!issueResolvedNote || issueResolvedNote == "") {
      setError(["Internal Notes Required"]);
      return;
    }
    let resolveEscal = {
      escalationId: escalation.id,
      stnUserId: user.id,
      issueResolvedNote: issueResolvedNote,
      jobStatusName: resolveOptions == "cancelJob" ? "Canceled" : "Active",
      returnJobToBee: resolveOptions == "returnToOwner"
    };
    try {
      let res = await initResolveEscalationApi(resolveEscal).unwrap();
      if(res.status == 'Failed'){
        setResolveEscalationError(res.message);
        return;
      }
      history.push("/dashboard/admintools?tab_index=0") // BEE-579 REDIRECT TO JOBS when an escalation is resolved
      //window.location.reload(); 
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Fragment>
      <div className="row-modal">
        <div className="name-date">
          <p style={{ fontSize: "var(--caption)", marginRight: "2em" }}>
            Created by{" "}
            {escalation?.hiveUser?.firstName +
              " " +
              escalation?.hiveUser?.lastName}
          </p>
          <p style={{ fontSize: "var(--caption)" }}>
            {parseToEasternTime(escalation?.issueCreated)}
          </p>
        </div>


      </div>

      <div className="escalation-selectors">
        <div className="input-column" style={{ marginRight: "2em" }}>
          <label>Escalation Reason</label>
          <div style={{ fontSize:"1rem", fontWeight:600 }}> 
            {escalationReasons.data?.find((mainReason) => mainReason.id === escalation?.jobEscalationMainReasonId)?.name}
          </div>
          <div>
            {escalationReasons.data?.find((mainReason) => mainReason.id === escalation?.jobEscalationMainReasonId)?.jobEscalationSubReason.find((SubReason) => SubReason.id === escalation?.jobEscalationSubReasonId)?.name}
          </div>
        </div>
      </div>

      <div className="notes-container">
        <div>
          <p style={{ color: "var(--orange)", margin: '0 0 1em 0' }}>User Notes</p>
          <p>{escalation.issueNote}</p>
        </div>

        <div className="escalation-text">
          <p style={{ color: "var(--orange)", margin: '1em 0' }}>Internal Notes</p>
          <textarea
            name="Internal Notes"
            disabled={!userCanEditJob}
            cols="40"
            rows="5"
            onChange={(e) => setissueResolvedNote(e.target.value)}
            value={issueResolvedNote}
          />
        </div>
      </div>

      <ul>
        {error.map((oneError) => (
          <li style={{ color: "var(--red)" }}>{oneError}</li>
        ))}
      </ul>

      <div className="column-modal" style={{ justifyContent: 'flex-end', alignItems: 'flex-end' }} >
        <div className="modal-buttons" style={{ width: 'fit-content', margin: '0 0 1em 0', alignItems: 'center' }}>

          <RadioButton
            style={{ margin: "0 0.5em 0 0" }}
            value={resolveOptions == "returnToOwner"}
            onChange={handleReturnToOwner}
            disabled={!jobInfo || !jobInfo.lastOwnerHiveUserId || !userCanEditJob}
          />
          <label
            htmlFor="completeNoBought"
            style={{ fontWeight: "700", marginRight: "1em" }}
          >
            {!jobInfo || !jobInfo.lastOwnerHiveUserId ?
              "can not return to bee" :
              getReturnToBeeLabel(jobInfo.lastOwnerHiveUser)
            }

          </label>

        </div>

        <div className="modal-buttons" style={{ width: 'fit-content', alignItems: 'flex-start' }}>
          <DeleteJobActionButton disabled={!userCanEditJob} jobId={jobInfo.id}/>
          <Button variant="contained" color="secondary" style={{marginLeft: '20px'}} >Cancel Changes</Button>
          <Button
            variant="contained"
            // style={(userCanEditJob) ? { margin: '0 0 0 1em' }
            //   :
            //   {
            //     marginLeft: '1em',
            //     backgroundColor: 'var(--grey-inactive)',
            //     color: 'white',
            //     borderRadius: '2em'
            //   }}
            style={{ margin: '0 0 0 1em' }} 
            onClick={() => setConfirmEdit(true)}
            disabled={!userCanEditJob}
          >
            Save And Set As Active
          </Button>

        </div>
      </div>

      <BasicModalConfirmation
        open={confirmEdit}
        handleClose={() => setConfirmEdit(false)}
        title="Are you sure you want to edit this escalation?"
        onClick={onLocalSubmit}
      />

      <BasicModalInformation
        title= {resolveEscalationError}
        open= {resolveEscalationError}
        handleClose={()=>{window.location.reload()}}
      />
    </Fragment>
  );
}

export default ResolveEscalationModal;
